import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import { updateMeasure } from '../thunk';

import type { MeasureInputType } from '@/domain/measure/component/MeasureFormInput';
import type { ChildJson } from '@/types/domain/child/entities/childEntity';
import type { MeasureJson } from '@/types/domain/measure/entities/measureEntity';
import type { UserType } from '@/types/domain/user/redux';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import MeasureFormInput from '@/domain/measure/component/MeasureFormInput';

/**
 * プロパティ
 */
export type Props = {
  /** データ */
  data: MeasureJson,
  /** 閉じる */
  close: () => void,
  /** ユーザー */
  user: UserType,
  /** 子ども */
  child: ChildJson,
};

const EditMeasure: React.FC<Props> = ({
  close,
  data,
  user,
  child,
}) => {
  const {
    height,
    weight,
    headCircumference,
    chestCircumference,
  } = data.data;
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<MeasureInputType>({
    defaultValues: {
      height: height ? height.toString() : '',
      weight: weight ? weight.toString() : '',
      headCircumference:
        headCircumference
          ? headCircumference.toString()
          : '',
      chestCircumference:
        chestCircumference
          ? chestCircumference.toString()
          : '',
    },
  });
  const onSubmit = (input: MeasureInputType) => {
    const username = user.name;
    const height = parseFloat(input.height);
    const weight = parseFloat(input.weight);
    const headCircumference = parseFloat(input.headCircumference);
    const chestCircumference = parseFloat(input.chestCircumference);
    dispatch(updateMeasure({
      data: {
        measureDate: (new Date()).toJSON(),
        height: Number.isNaN(height) ? undefined : height,
        weight: Number.isNaN(weight) ? undefined : weight,
        headCircumference: Number.isNaN(headCircumference) ? undefined : headCircumference,
        chestCircumference: Number.isNaN(chestCircumference) ? undefined : chestCircumference,
        measurerId: username,
        measurerType: 'app',
        parentId: username,
        childId: child.childId,
      },
      pub: {
        sendId: username,
        replyId: username,
        data: {},
      },
    }));
    close();
  };
  return (
    <Dialog
      open
      onClose={() => close()}
      TransitionComponent={DialogTransition}
      fullScreen
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle title="計測の編集" />
        <DialogContent>
          <MeasureFormInput
            control={control}
            errors={errors}
          />
        </DialogContent>
        <DialogActions>
          <Button
            type="submit"
            color="primary"
            variant="contained"
          >
            保存する
          </Button>
          <Button
            onClick={() => close()}
            color="primary"
            variant="contained"
          >
            閉じる
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditMeasure;
